import { Badge, BadgeProps } from '@shadcn/ui/components/ui/badge';
import { cn } from '@shadcn/ui/lib/utils';
import * as React from 'react';

export const RecommendedActionBadge: React.FC<{ text: string; color: BadgeProps['variant'] }> = ({
    text,
    color = 'success',
}) => {
    return (
        <Badge variant={color}>
            <div className="flex flex-row gap-2 items-center">
                {/* <div className={cn('w-1.5 h-1.5 rounded-full', `bg-${color}-700 dark:bg-${color}-500`)} /> */}
                {text}
            </div>
        </Badge>
    );
};
